<template>
  <section class="description">
    <div class="main-description-wrapper">
      <header class="jewel-breadcrumbs">
        <breadcrumbs
          v-if="jewel.vendor_code_alias"
          v-bind:names="breadcrumbName"
        ></breadcrumbs>
      </header>
      <div class="main-description">
        <catalog-jewel-article-description-header
          v-bind:jewel="jewel"
        ></catalog-jewel-article-description-header>
        <catalog-jewel-article-description-note-with-vendor-code
          v-bind:jewel="jewel"
        ></catalog-jewel-article-description-note-with-vendor-code>
        <catalog-jewel-article-description-price
          v-bind:jewel="jewel"
        ></catalog-jewel-article-description-price>
        <catalog-jewel-article-description-physical-dimensions
          v-bind:jewel="jewel"
        ></catalog-jewel-article-description-physical-dimensions>
      </div>
      <catalog-jewel-article-description-scroll-links
        v-bind:jewel="jewel"
        v-on:scroll-to="$emit('scroll-to', $event)"
      ></catalog-jewel-article-description-scroll-links>
    </div>
  </section>
</template>

<script>
import Breadcrumbs from '@/components/utils/Breadcrumbs'

import CatalogJewelArticleDescriptionHeader from
  './catalog-jewel-article-description/CatalogJewelArticleDescriptionHeader'

import CatalogJewelArticleDescriptionNoteWithVendorCode from
  './catalog-jewel-article-description/CatalogJewelArticleDescriptionNoteWithVendorCode'

import CatalogJewelArticleDescriptionPrice from
  './catalog-jewel-article-description/CatalogJewelArticleDescriptionPrice'

import CatalogJewelArticleDescriptionPhysicalDimensions from
  './catalog-jewel-article-description/CatalogJewelArticleDescriptionPhysicalDimensions'

import CatalogJewelArticleDescriptionScrollLinks from
  './catalog-jewel-article-description/CatalogJewelArticleDescriptionScrollLinks'

export default {
  name: 'CatalogJewelArticleDescription',
  components: {
    Breadcrumbs,
    CatalogJewelArticleDescriptionHeader,
    CatalogJewelArticleDescriptionNoteWithVendorCode,
    CatalogJewelArticleDescriptionPrice,
    CatalogJewelArticleDescriptionPhysicalDimensions,
    CatalogJewelArticleDescriptionScrollLinks
  },
  props: ['jewel'],
  data: function () {
    return {}
  },
  computed: {
    breadcrumbName: function () {
      let breadcrumbName = this.jewel.title
      if (this.jewel.vendor_code) {
        breadcrumbName += ` ${this.jewel.vendor_code}`
      }
      return { [this.jewel.vendor_code_alias]: breadcrumbName }
    }
  }
}
</script>

<style scoped lang="scss">
  $description-padding: 3em;

  .description {
    background-color: $default-background-color;
    display: flex;
    flex-direction: column;

    @include media (">tablet") {
      flex-basis: 50%;
      max-width: 50%;
    };
    @include media (">mobile") {
      text-align: left;
    };

    & > .main-description-wrapper {
      display: flex;
      flex: 1 100%;
      flex-direction: column;
      justify-content: center;

      padding: $description-padding 0;
      $total-padding: (2 * $description-padding);

      @include media (">desktop") {
        $the-header-height: (
          $the-header-main-height +
          $the-header-contacts-height
        );
        max-height: calc(100vh - #{$the-header-height} - #{$total-padding});
      };
      @include media (">tablet", "<=desktop") {
        $the-header-height: $the-header-main-height;
        max-height: calc(100vh - #{$the-header-height} - #{$total-padding});
      };
      @include media ("<=mobile") {
        padding-top: 1.5em;
      }

      & > * {
        padding-left: 1em;
        @include centered-block-width();
        @include media ("<=mobile") {
          padding-left: 0;
        };
      }

      & > .jewel-breadcrumbs { margin-bottom: 1em; }
      & > .main-description {
        padding-top: 2em;
        padding-bottom: 2em;
        border-top: 1px solid $default-text-color;
        border-bottom: 1px solid $default-text-color;

        & > *:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/catalog-jewel-article/CatalogJewelArticleDescription.vue